import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

export const ScrollToTopButton = ({ scrollToTop }: { scrollToTop: () => void }) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      scrollToTop();
    }
  };

  return (
    <button
      onClick={scrollToTop}
      onKeyDown={handleKeyDown}
      className="fixed bottom-4 right-4 border-2 border-gray-300 text-white p-2 rounded-full shadow-lg cursor-pointer bg-white"
      aria-label="Scroll to top"
      type="button"
    >
      <ArrowUpwardIcon className='text-black'/>
    </button>
  );
};